import React, { Component } from 'react';

export class PendingCognitoAuth extends Component {
  render() {
    return (
      <div className={'qa-pending-cognito-auth'}>
        <h3>Account registration complete.&nbsp; Awaiting account activation by Beam Financing Technology</h3>
      </div>
    );
  }
}
